<template>
  <div class="footer">
    <h1 class="title">Хочешь работать в Createx? Напиши нам</h1>
    <div class="footer-links">
      <a href="mailto:hr@createx.by"
        ><img src="../assets/images/footer/Gmail.svg"
      /></a>
      <a href="https://www.linkedin.com/company/createxby"
        ><img src="../assets/images/footer/LinkedIn.svg"
      /></a>
    </div>
    <div class="text">А также можешь следить за нами в соцсетях</div>
    <div class="footer-links">
      <a
        href="https://www.instagram.com/createx.by?igsh=Mnkwb2dtNjU4eXBi"
        class="small"
        ><img src="../assets/images/footer/Instagram.svg"
      /></a>
      <a
        href="https://www.tiktok.com/@team.createx?_t=8rNraKlQwXo&_r=1"
        class="small"
        ><img src="../assets/images/footer/TikTok.svg"
      /></a>
    </div>
    <div class="copyright">© ООО “Крейтекс”, 2024</div>
    <div class="bg-image">
      <img src="../assets/images/footer/footer-background.png" />
    </div>
    <div class="company-text">
      <img src="../assets/images/footer/createx-text.svg" />
    </div>
  </div>
</template>

<script>
export default {
  name: "FooterCopyright",
};
</script>

<style lang="sass">
@import "../styles/variables.sass"

.footer
  padding: 48px 16px 24px
  position: relative
  overflow: hidden
  display: flex
  flex-direction: column
  justify-content: center
  align-items: center

  @media screen and (min-width: $tablet)
    padding: 56px 24px 24px

  // Figma 1200 / 1440 / 1920
  @media screen and (min-width: $desktop_xs)
    padding: 69px 32px 24px

  .title
    font-size: 32px
    font-weight: 510
    line-height: 1.3
    text-align: center
    color: #FFFFFF
    margin-bottom: 24px
    max-width: 920px
    z-index: 1

    @media screen and (min-width: $tablet)
      font-size: 44px

    @media screen and (min-width: $desktop_xs)
      font-size: 56px
      line-height: 72.8px

  .footer-links
    display: flex
    flex-direction: row
    flex-wrap: wrap
    justify-content: center
    gap: 24px
    margin-bottom: 36px
    z-index: 1

    @media screen and (min-width: $tablet)
      gap: 32px

    @media screen and (min-width: $desktop_xs)
      gap: 40px
      margin-bottom: 44px

    a
      width: 64px
      height: 64px
      cursor: url("../assets/cursor.svg"), auto
      border-radius: 40000px
      box-shadow: 0px 0px 1px 0px #5853A240, 1px 2px 2px 0px #5853A236, 2px 4px 3px 0px #5853A221, 3px 7px 3px 0px #5853A20A, 5px 12px 4px 0px #5853A200
      flex-shrink: 0

      @media screen and (min-width: $tablet)
        width: 72px
        height: 72px

      @media screen and (min-width: $desktop_xs)
        width: 80px
        height: 80px

      &:hover
        border-radius: 800px

      &.small
        width: 56px
        height: 56px

        @media screen and (min-width: $tablet)
          width: 64px
          height: 64px

        @media screen and (min-width: $desktop_xs)
          width: 70px
          height: 70px

      img
        width: 100%
        height: 100%
        object-fit: contain

  .text
    opacity: 60%
    font-size: 24px
    font-weight: 510
    line-height: 1.3
    text-align: center
    color: #FFFFFF
    margin-bottom: 24px
    max-width: 720px
    z-index: 1
    padding: 0 8px

    @media screen and (min-width: $tablet)
      font-size: 32px

    @media screen and (min-width: $desktop_xs)
      font-size: 40px
      line-height: 52px

  .copyright
    opacity: 50%
    font-size: 16px
    font-weight: 400
    line-height: 1.5
    text-align: center
    color: #FFFFFF
    margin-top: 40px
    z-index: 1

    @media screen and (min-width: $desktop_xs)
      font-size: 18px
      margin-top: 60px

  .bg-image
    width: 100%
    height: 100%
    position: absolute
    top: 0
    left: 0
    z-index: 0
    pointer-events: none

    img
      object-fit: cover
      width: 100%
      height: 100%

  .company-text
    width: min(100%, 1200px)
    position: absolute
    bottom: 0
    left: 50%
    transform: translateX(-50%)
    z-index: 0
    pointer-events: none

    img
      display: block
      width: 100%
      height: auto
      max-height: 120px
      object-fit: contain
      object-position: bottom center

      @media screen and (min-width: $tablet)
        max-height: 160px

      @media screen and (min-width: $desktop_xs)
        max-height: 220px
</style>
